import 'index.css';
import './Seance.scss';

import React, {Component} from 'react';

import BookButton from 'components/BookButton';
import Button from '@material-ui/core/Button';
import CartoucheSeance from 'components/CartoucheSeance';
import Chat from 'components/Chat/Chat';
import Checkbox from '@material-ui/core/Checkbox';
import Conf from 'utils/Conf';
import Context from 'utils/Context';
import CountDown from 'components/CountDown';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import LanguageSelector from 'components/LanguageSelector';
import LinearProgress from '@material-ui/core/LinearProgress';
import Paiement from 'components/Paiement/Paiement';
import PaiementHorsZone from 'components/Paiement/PaiementHorsZone';
import Preload from 'preload-it';
import Qs from 'qs';
import SeanceLogin from 'components/Auth/SeanceLogin';
import TimeCounter from 'utils/TimeCounter';
import Typography from '@material-ui/core/Typography';
import Utils from 'utils/Utils';
import VideoPlayer from 'components/VideoPlayer';
import _ from 'lodash';
import axios from 'axios';
import defaultCinemaBackground from '../assets/cinema-background.jpg';
import moment from 'moment';
import {withTranslation} from 'react-i18next';

const preload = Preload();

class Seance extends Component {
  constructor(props) {
    super(props);
    this.state = {
      left: 0,
      top: 0,
      ratio: 1,
      accessGranted: false,
      checkOpen: false,
      bookOpen: false,
      seanceLoginOpen: false,
      seanceStarted: false,
      liveStarted: false,
      seanceStartSoon: false,
      players: [],
      endedVideos: [],
      playList: [],
      intro: [{url: Conf.assetsRoot + '/25eh.mp4'}, {url: Conf.assetsRoot + '/countdown.mp4'}],
      // intro: [{url: '../assets/25eh.mp4'}, {url: '../assets/countdown.mp4'}],
      playListReady: false,
      videoNeedInteraction: false,
      filmEnded: false,
      ready: false,
      introReady: false,
      showControls: false,
      liveFull: false,
      seanceIndex: null,
      position: 0,
      currentTime: 0,
      lastCurrentTime: -1,
      nbPlay: 0,
      nbPause: 0,
      nbSeek: 0,
      bufferingTime: 0,
      preloadProgress: 0,
      accessDeniedMsg: false,
      chat: [],
      showChat: false,
      chatState: -1,
      user: {},
      news: [],
      newsLetter: [],
    };
    this.videoRef = React.createRef();
    this.salleRef = React.createRef();
    this.timeCounter = new TimeCounter(this.sendViewStats);
    this.statInterval = 0;
    this.presenceTick = this.presenceTick.bind(this);
    this.presenceLeave = this.presenceLeave.bind(this);
    this.handleAccessDenied = this.handleAccessDenied.bind(this);
    this.exit = this.exit.bind(this);
    this.presenceInterval = 0;
    this.noOtherTab = true;
    this.handleChangeNewslettersSeance = this.handleChangeNewslettersSeance.bind(this);
  }
  updateSeance = () => {
    const {appState} = this.context;
    if (this.state.accessGranted) {
      axios
        .get(Conf.apiBaseUriLegacy + '/seance/' + this.props.params.id + '/full', {
          params: {
            hash: this.props.params.hash,
            uuid: appState.uuid,
          },
          withCredentials: true,
        })
        .then(res => {
          if (res.data.authorized) {
            let shouldUpdate = false;
            const seanceSrv = res.data.seance;
            let seanceState = {
              ...this.state.seance,
            };
            if (seanceState.live_id !== seanceSrv.live_id) {
              seanceState.live_id = seanceSrv.live_id;
              shouldUpdate = true;
            }
            let playList = this.state.playList;
            let filmVideo = _.find(playList, {type: 'film'});
            if (filmVideo && filmVideo.id !== seanceSrv.video_id) {
              filmVideo.id = seanceSrv.video_id;
              seanceState.position = this.state.lastCurrentTime;
              seanceState.video_id = seanceSrv.video_id;
              shouldUpdate = true;
            }
            if (shouldUpdate) {
              this.setState({
                seance: seanceState,
                playList,
              });
            }
          }
          return;
        });
    }
  };
  checkAccess() {
    const {appState} = this.context;
    const {params} = this.props;
    axios
      .get(Conf.apiBaseUriLegacy + '/access/seance/' + params.id, {
        params: {
          hash: params.hash,
          uuid: appState.uuid,
        },
        withCredentials: true,
      })
      .then(res => {
        if (res.data.authorized) {
          this.handleSuccess();
        } else {
          if (res.data.authorized) {
            this.handleSuccess();
          } else {
            this.handleAccessDenied(res.data.msg);
          }
        }
        return;
      });
  }
  checkVideoState = video => {
    if (this.state.seanceStarted && video.type === 'film') {
      if (this.state.lastCurrentTime === -1) {
        this.setState({lastCurrentTime: this.state.currentTime});
      } else {
        let bufferingTime = this.state.bufferingTime;
        let currentTime = video.player.current.state.currentTime;
        if (!video.paused && this.state.lastCurrentTime === currentTime) {
          bufferingTime++;
          this.setState({bufferingTime: bufferingTime, lastCurrentTime: currentTime});
        } else {
          this.setState({lastCurrentTime: currentTime});
        }
        this.timeCounter.tick(video.id, currentTime);
      }
    }
  };
  presenceTick = () => {
    let {appState} = this.props;
    if (!this.state.seance) return;
    axios
      .post(
        Conf.apiBaseUriLegacy + '/presence_tick/' + this.props.params.id,
        Qs.stringify({
          state: 1,
          hash: this.props.params.hash,
          uuid: appState.uuid,
          email: appState.user ? appState.user.email : '',
          event_id: this.state.seance?.event_id,
          chat_state: this.state.chatState,
        }),
        {
          withCredentials: true,
        },
      )
      .then(res => {
        const messagesState = this.state.chat;
        let chat = res.data.chat;

        let updatedMessagesState = [...messagesState];
        chat.forEach(newMessage => {
          const existingMessageIndex = updatedMessagesState.findIndex(m => m.id === newMessage.id);
          if (existingMessageIndex !== -1) {
            updatedMessagesState[existingMessageIndex] = {
              ...newMessage,
              delay: 0,
            };
          } else {
            updatedMessagesState.unshift(newMessage);
          }
        });

        // If some messages remains in update list, they are new messages, so add them to the messages list
        this.setState({
          chatState: res.data.chat_state,
          chat: updatedMessagesState,
        });
      });
  };
  presenceLeave = () => {
    let {appState} = this.props;
    axios.post(
      Conf.apiBaseUriLegacy + '/presence_tick/' + this.props.params.id,
      Qs.stringify({
        state: 0,
        uuid: appState.uuid,
        email: appState.user ? appState.user.email : '',
        event_id: this.state.seance?.event_id,
        chat_state: this.state.chatState,
      }),
      {
        withCredentials: true,
      },
    );
  };
  sendViewStats = (t, tc) => {
    if (this.state.seanceStarted) {
      let positionDuDirect = moment().unix() - moment(this.state.filmStartAt).unix();
      let setPosition = Math.max(0, Math.min(positionDuDirect, t));
      axios.post(
        Conf.apiBaseUriLegacy + '/view_stats/' + this.props.params.id,
        Qs.stringify({
          t: setPosition,
          total_vu: tc.items[0].total,
          ranges: tc.items[0].ranges,
          buffering_time: this.state.bufferingTime,
        }),
        {
          withCredentials: true,
        },
      );
      this.setState({
        position: setPosition,
        currentTime: t,
      });
    }
  };
  autoPlayCheck = () => {
    const player = this.videoRef.current;
    if (player) {
      let playPromise = player.play();
      if (playPromise !== undefined) {
        playPromise
          .then(() => {
            player.pause();
            this.setState({videoNeedInteraction: false}, this.handleSuccess);
          })
          .catch(e => this.setState({videoNeedInteraction: true}));
      } else {
        player.pause();
        if (!this.testClick) {
          this.testClick = true;
          this.setState({videoNeedInteraction: true});
        } else {
          this.setState({videoNeedInteraction: false});
          this.handleSuccess();
        }
      }
    }
  };
  handleAccessDenied = msg => {
    let m = msg;
    const {t, params} = this.props;
    const {appState} = this.context;
    if (['full', 'already', 'lien privé invalide', 'otherTab', 'noSeance'].indexOf(m) !== -1) {
      if (msg === 'full')
        m = (
          <>
            {t('la-seance-est-complete')}
            <br /> {t('merci-dessayer-plus-tard')}
          </>
        );
      if (msg === 'already') m = <>{t('utilisateur-connecte-avec-un-autre-appareil')}</>;
      if (msg === 'lien privé invalide') m = t('cette-page-nexiste-pas');
      if (msg === 'noSeance') m = t('cette-page-nexiste-pas');
      if (msg === 'otherTab') {
        m = t('page-ouverte-dans-un-autre-onglet');
        this.noOtherTab = false;
      }
      this.setState({
        accessDeniedMsg: m,
      });
    } else {
      if (params.hash && params.hash !== '') {
        this.setState({
          accessDeniedMsg: t('cette-page-nexiste-pas'),
        });
      } else {
        if (!appState.user.email) {
          this.handleSeanceLoginOpen();
        } else {
          this.handleCheckOpen();
        }
      }
    }
  };
  handleCheckOpen = () => {
    if (this.state.seanceIndex.prix > 0 || this.state.seanceIndex.access_by_promo_code_only) {
      this.setState({
        checkOpen: true,
      });
    } else {
      this.setState({
        bookOpen: true,
      });
    }
  };
  handleLoggedIn = () => {
    this.setState({seanceLoginOpen: false});
    this.checkAccess();
  };
  handleSeanceLoginOpen = () => {
    this.setState({seanceLoginOpen: true});
  };
  handleSeanceLoginClose = () => {
    this.setState({seanceLoginOpen: false});
  };
  handleShowControls = () => {
    this.setState({showControls: true});
  };
  handleHideControls = () => {
    this.setState({showControls: false});
  };
  handleCheckClose = () => {};
  skipToNow = () => {
    const {appState} = this.context;
    let delta = moment().diff(this.state.seanceStartAt, 'seconds');
    if (delta >= 0) {
      let filmVideo = _.find(this.state.playList, {type: 'film'});
      let direct = delta / filmVideo.duration;
      let directMin = (delta - appState.conf.RETARD_MAX * 60) / filmVideo.duration;
      if (this.state.seance.position >= 0) {
        if (
          this.state.seance.position > filmVideo.duration - 5 &&
          directMin * filmVideo.duration > filmVideo.duration - 5
        ) {
          this.setState(
            {
              filmEnded: true,
              playList: [],
              intro: [],
            },
            this.playIntro,
          );
        } else {
          if (this.state.seance.position < directMin * filmVideo.duration) {
            filmVideo.player.current.handlePositionUpdate(directMin);
          } else if (this.state.seance.position > direct * filmVideo.duration) {
            filmVideo.player.current.handlePositionUpdate(direct);
          } else {
            filmVideo.player.current.handlePositionUpdate(this.state.seance.position / filmVideo.duration);
          }
          this.setState(
            {
              filmEnded: false,
              playList: [filmVideo],
              intro: [],
            },
            this.playIntro,
          );
        }
      } else {
        this.setState({intro: []}, () => {
          let playList = this.state.playList;
          while (playList.length > 0 && delta > playList[playList.length - 1].duration) {
            delta -= playList[playList.length - 1].duration;
            playList.splice(playList.length - 1, 1);
          }
          if (playList.length > 0) {
            playList[playList.length - 1].player.current.handlePositionUpdate(
              delta / playList[playList.length - 1].duration,
            );
          }
          let filmEnded = this.state.filmEnded;
          if (playList.length === 0) filmEnded = true;
          this.setState(
            {
              filmEnded: filmEnded,
              playList: playList,
            },
            this.playIntro,
          );
        });
      }
    }
  };
  resize = () => {
    let w = window.innerWidth;
    let h = window.innerHeight;
    let sw = Conf.screenWidth;
    let sh = Conf.screenHeight;
    let left = 0;
    let top = 0;
    let width = w;
    let height = h;
    let ratio = 1;
    if (w / h >= sw / sh) {
      ratio = h / sh;
      width = sw * ratio;
      left = (w - width) / 2;
    }
    if (w / h < sw / sh) {
      ratio = w / sw;
      height = sh * ratio;
      top = (h - height) / 2;
    }
    this.setState({
      left: left,
      top: top,
      ratio: ratio,
    });
  };
  calculateStartTime = () => {
    let {seance} = this.state;
    const {appState} = this.context;
    let introDuration = 0;
    let filmDuration = 0;
    this.state.playList.forEach(video => {
      if (['bande_annonce', 'intro', 'jingle'].indexOf(video.type) !== -1) {
        introDuration += video.duration;
      }
      if (['film'].indexOf(video.type) !== -1) {
        filmDuration = video.duration;
        this.setState({filmDuration: filmDuration});
      }
    });
    let filmStartAt, seanceStartAt, liveStartAt;
    if (Boolean(seance.event_id)) {
      filmStartAt = moment(this.state.debutAt)
        .add(appState.conf.AVANT_SEANCE, 'minutes')
        .format();
      seanceStartAt = moment(filmStartAt)
        .subtract(introDuration, 'seconds')
        .format();
      liveStartAt = moment(filmStartAt)
        .add(filmDuration, 'seconds')
        .format();
    } else {
      seanceStartAt = moment(this.state.debutAt).format();
      filmStartAt = moment(seanceStartAt)
        .add(introDuration, 'seconds')
        .format();
      liveStartAt = moment(filmStartAt)
        .add(filmDuration, 'seconds')
        .format();
    }
    let started = moment().diff(seanceStartAt, 'seconds') > -7;
    let startSoon = moment().diff(seanceStartAt, 'seconds') > -15;
    let ready = false;
    if (this.state.introReady) {
      ready = true;
    }
    this.setState(
      {
        filmStartAt,
        seanceStartAt,
        liveStartAt,
        seanceStarted: started,
        seanceStartSoon: startSoon,
        calculReady: true,
        ready: ready,
      },
      this.skipToNow,
    );
  };
  pushToPlayList = (id, type, playList) => {
    let idx = _.findIndex(playList, {id: id});
    if (idx === -1) playList.push({type: type, id: id, paused: true, player: React.createRef()});
  };
  handleSuccess = () => {
    let {appState} = this.context;
    this.setState({checkOpen: false, bookOpen: false});
    axios
      .get(Conf.apiBaseUriLegacy + '/seance/' + this.props.params.id + '/full', {
        params: {
          hash: this.props.params.hash,
          uuid: appState.uuid,
        },
        withCredentials: true,
      })
      .then(res => {
        if (res.data.authorized) {
          const seance = res.data.seance;
          let debutAt = moment(Date.now() + res.data.time);
          let playList = [];
          if (seance.video_id) this.pushToPlayList(seance.video_id, 'film', playList);
          if (seance.intro_id) this.pushToPlayList(seance.intro_id, 'intro', playList);
          if (seance.bande_annonce_admin) this.pushToPlayList(seance.bande_annonce_admin, 'bande_annonce', playList);
          if (seance.jingle_id) this.pushToPlayList(seance.jingle_id, 'jingle', playList);
          this.setState(
            {
              seance: {
                ...seance,
                tzStartTime: moment.tz(seance.start_time, seance.zone_name).format(),
              },
              debutAt: debutAt,
              accessGranted: true,
              playList: playList,
              position: res.data.seance.position,
              bufferingTime: res.data.seance.buffering_time,
            },
            () => {
              if (seance.ranges)
                this.timeCounter.update(res.data.seance.position, {
                  total: seance.total_vu,
                  items: [{id: seance.video_id, total: seance.total_vu, ranges: seance.ranges}],
                });
              return null;
            },
          );
          this.presenceTick();
          this.presenceInterval = setInterval(this.presenceTick, 5000);
        } else {
          this.handleAccessDenied(res.data.msg);
        }
        return null;
      });
  };
  nextIntro = () => {
    let intro = _.cloneDeep(this.state.intro);
    intro.splice(intro.length - 1, 1);
    this.setState({intro: intro}, this.playIntro);
  };
  playIntro = () => {
    let intro = this.state.intro;
    if (intro.length > 0) {
      let item = intro[intro.length - 1];
      let player = item.ref.current;
      player.addEventListener('ended', this.nextIntro);
      player.play();
    } else {
      let playList = this.state.playList;
      if (playList.length > 0) this.play(playList[playList.length - 1].id);
    }
  };
  seanceInit = () => {
    const {seanceIndex, intro, calculReady} = this.state;
    const {appState, geoloc, country} = this.context;
    this.setState(
      {
        seanceIndex: {
          ...seanceIndex,
          local: Utils.isSeanceLocal(seanceIndex, geoloc, country),
        },
      },
      () => {
        if (this.noOtherTab) {
          let jsonPromise = axios.get(Conf.apiBaseUriLegacy + '/access/seance/' + this.props.params.id, {
            params: {
              hash: this.props.params.hash,
              uuid: appState.uuid,
            },
            withCredentials: true,
          });
          let tab = [];
          intro.map(item => tab.push(item.url));
          let preloadPromise = preload.fetch(tab);
          preload.onprogress = event => {
            this.setState({preloadProgress: event.progress});
          };
          Promise.all([jsonPromise, preloadPromise]).then(values => {
            let ready = false;
            if (calculReady) ready = true;
            this.setState({preloadProgress: 100});
            values[1].map(item => {
              if (item.blobUrl) {
                let introItem = _.find(intro, {url: item.url});
                introItem.fileName = item.fileName;
                introItem.blobUrl = item.blobUrl;
                introItem.ref = React.createRef();
              }
              return null;
            });
            this.setState({intro: intro, introReady: true, ready: ready}, () => {
              if (values[0].data.authorized) {
                this.autoPlayCheck();
              } else {
                this.handleAccessDenied(values[0].data.msg);
              }
              return null;
            });
            return null;
          });
        }
      },
    );
  };
  componentDidMount() {
    window.addEventListener('resize', this.resize);
    document.addEventListener('fullscreenchange', this.handleFullscreenChange);
    this.resize();
    const {geoloc} = this.context;
    if (geoloc) {
      this.initOk = true;
      axios
        .get(Conf.apiBaseUriLegacy + '/seance/' + this.props.params.id + '/index', {withCredentials: true})
        .then(res => {
          if (res.data.seance && res.data.seance.length !== 0) {
            this.setState({seanceIndex: res.data.seance}, this.seanceInit);
          } else this.handleAccessDenied('noSeance');
        })
        .catch(() => this.handleAccessDenied('noSeance'));
    }
    this.interval = setInterval(this.updateSeance, 60000);
    window.addEventListener('unload', this.exit, false);
    //NEWSLETTER
    axios.get(Conf.apiBaseUriLegacy + '/newsletters', {withCredentials: true}).then(res => {
      this.setState({
        news: res.data,
        newsletter: res.data ? res.data.filter(n => n.cinema_id === parseInt(this.state.seanceIndex?.cinema_id)) : [],
      });
    });
  }
  componentDidUpdate(prevProps) {
    const {geoloc} = this.context;
    if (!this.initOk && geoloc) {
      this.initOk = true;
      axios
        .get(Conf.apiBaseUriLegacy + '/seance/' + this.props.params.id + '/index', {withCredentials: true})
        .then(res => {
          if (res.data.seance && res.data.seance.length !== 0)
            this.setState({seanceIndex: res.data.seance}, this.seanceInit);
          else this.handleAccessDenied('noSeance');
        })
        .catch(() => this.handleAccessDenied('noSeance'));
    }
  }
  componentWillUnmount() {
    clearInterval(this.interval);
    window.removeEventListener('resize', this.resize);
    window.removeEventListener('unload', this.exit);
    document.removeEventListener('fullscreenchange', this.handleFullscreenChange);
    clearInterval(this.statInterval);
    clearInterval(this.presenceInterval);
    this.presenceLeave();
  }
  exit() {
    if (navigator.sendBeacon) {
      let {appState} = this.props;
      navigator.sendBeacon(
        Conf.apiBaseUriLegacy +
          '/presence_tick/' +
          this.props.params.id +
          '?' +
          Qs.stringify({
            state: 0,
            uuid: appState.uuid,
            email: appState.user ? appState.user.email : '',
            event_id: this.state.seance && this.state.seance.event_id,
            chat_state: this.state.chatState,
            hash: this.props.params.hash,
          }),
      );
    }
  }
  handlePlay = () => {
    this.setState({playing: true});
  };
  play = id => {
    let playList = this.state.playList;
    let video = _.find(playList, {id: id});
    video.paused = false;
    video.started = true;
    let nbPlay = this.state.nbPlay;
    if (video.type === 'film') nbPlay++;
    this.setState({playList: playList, nbPlay: nbPlay});
    if (video.type === 'film' && this.statInterval === 0)
      this.statInterval = setInterval(() => this.checkVideoState(video), 1000);
  };
  pause = id => {
    let playList = this.state.playList;
    let video = _.find(playList, {id: id});
    video.paused = true;
    let nbPause = this.state.nbPause;
    if (video.type === 'film') nbPause++;
    this.setState({playList: playList, nbPause: nbPause});
  };
  togglePlay = id => {
    let playList = this.state.playList;
    let video = _.find(playList, {id: id});
    video.paused = !video.paused;
    let nbPlay = this.state.nbPlay;
    let nbPause = this.state.nbPause;
    if (video.type === 'film' && !video.paused) nbPlay++;
    if (video.type === 'film' && video.paused) nbPause++;
    this.setState({playList: playList, nbPlay: nbPlay, nbPause: nbPause});
  };
  handlePause = () => {
    this.setState({playing: false});
  };
  next = () => {
    let video = this.state.playList[this.state.playList.length - 1];
    this.handleEnd(video.id);
  };
  handleEnd = id => {
    let playList = this.state.playList;
    let video = _.find(playList, {id: id});
    let filmEnded = this.state.filmEnded;
    if (video.type === 'film') {
      clearInterval(this.statInterval);
      filmEnded = true;
      if (document.fullscreenElement) document.exitFullscreen();
    }
    playList.splice(playList.length - 1, 1);
    this.setState(
      {
        filmEnded: filmEnded,
        playList: playList,
      },
      () => playList.length > 0 && this.play(playList[playList.length - 1].id),
    );
  };
  handleSeanceStart = () => {
    let playList = this.state.playList;
    this.playIntro();
    this.setState({
      seanceStarted: true,
      playList: playList,
    });
  };
  handleLiveStart = () => {
    this.setState({
      liveStarted: true,
    });
  };
  handleSeanceStartSoon = () => {
    this.setState({seanceStartSoon: true});
  };
  handleShowChat = () => {
    this.setState({showChat: true});
  };
  doChatSend = message => {
    const {seance, chat} = this.state;
    axios
      .post(
        `${Conf.apiBaseUriLegacy}/event/${seance.event_id}/message/`,
        Qs.stringify({
          _method: 'POST',
          ...message,
        }),
        {withCredentials: true},
      )
      .then(({data}) => {
        this.setState({
          chat: [data, ...chat],
        });
      });
  };
  throttleChatSend = _.throttle(this.doChatSend, 500);
  handleChatSend = message => {
    if (message.msgType === 'emoji') this.throttleChatSend(message);
    else this.doChatSend(message);
  };
  playerReady = (id, duration) => {
    let playList = this.state.playList;
    let player = _.find(playList, {id: id});
    player.duration = duration;
    this.checkPlaylist();
  };
  playerError = (id, e) => {
    let playList = this.state.playList;
    let player = _.find(playList, {id: id});
    let idx = _.findIndex(playList, {id: id});
    if (!player.duration) {
      playList.splice(idx, 1);
      this.setState({playList}, this.checkPlaylist);
    }
  };
  handleFullscreenChange = () => {
    if (document.fullscreenElement) {
      this.setState({full: true});
      document.body.classList.add('fullscreen');
    } else {
      this.setState({full: false});
      document.body.classList.remove('fullscreen');
    }
  };
  toggleFullScreen = e => {
    e.stopPropagation();
    if (document.fullscreenElement) {
      document.exitFullscreen();
    } else {
      document.body.requestFullscreen();
    }
  };
  checkPlaylist = () => {
    let playList = this.state.playList;
    let test = true;
    playList.map(p => {
      if (!p.duration) test = false;
      return null;
    });
    if (test) {
      this.setState({playListReady: true}, this.calculateStartTime);
    }
  };
  getSeanceClasses = () => {
    let seanceClasses = 'seance-container';
    if (this.state.playing) seanceClasses += ' playing';
    if (this.state.seanceStarted) seanceClasses += ' started';
    if (this.state.filmEnded) seanceClasses += ' film-ended';
    if (this.state.seanceStartSoon && !this.state.filmEnded) seanceClasses += ' lights-fade';
    if (this.state.seanceStarted && !this.state.filmEnded) {
      seanceClasses += ' lights-off';
    }
    return seanceClasses;
  };
  renderMsg() {
    const {t} = this.props;
    if (this.state.endedVideos.length > 0) {
      return t('cette-seance-est-terminee');
    }
    if (this.state.playListReady) {
      return (
        <CountDown
          startAt={this.state.seanceStartAt}
          liveStartAt={this.state.liveStartAt}
          onStart={this.handleSeanceStart}
          onShowChat={this.handleShowChat}
          onStartSoon={this.handleSeanceStartSoon}
          onLiveStart={this.handleLiveStart}
        />
      );
    }
    return '';
  }
  renderTeaser() {
    const seanceFull = this.state.seance || null;
    if (this.state.playListReady && !this.state.seanceStarted) {
      return (
        <div className="seance-wait-screen">
          <CartoucheSeance {...this.props} hideBtns seance={seanceFull} />
        </div>
      );
    }
    return '';
  }
  renderLive() {
    const {seance, filmEnded} = this.state;

    const seanceFull = seance || null;
    if (!filmEnded || seanceFull.event_id <= 0) {
      return null;
    }
    return (
      <VideoPlayer
        key={seanceFull.live_id}
        video={seanceFull.live_id}
        paused={false}
        autoplay={true}
        onPlay={this.handlePlay}
        onPause={this.handlePause}
        node={this.salleRef.current}
        onShowControls={this.handleShowControls}
        onHideControls={this.handleHideControls}
        isLive
        {...this.props}
      />
    );
  }
  renderEcran(backgroundStyle) {
    if (!this.state.seance) return '';

    const {
      seanceIndex,
      seance,
      playing,
      seanceStarted,
      filmEnded,
      full,
      playList,
      introReady,
      intro,
      liveStarted,
      position,
      filmDuration,
    } = this.state;

    const {t} = this.props;

    if (!seanceIndex) {
      return '';
    }

    const seanceFull = seance || null;

    const isHalfRatioDisplay = (!playing && !seanceStarted) || (filmEnded && !full);
    const screenStyle = {
      transform: `scale(${isHalfRatioDisplay ? 0.52 : 1}) translateY(${isHalfRatioDisplay ? '-24%' : 0})`,
    };

    return (
      <div className="seance-screen" style={screenStyle}>
        <div className="seance-background" style={backgroundStyle}>
          <div className="screen-messages">
            <div className="screen-messages-inner">{this.renderMsg()}</div>
          </div>
        </div>
        <div className="screen-background"></div>
        {this.renderLive()}
        <div className={`seance-players${seanceStarted ? ' show' : ''}`}>
          {playList.map((video, i) => (
            <div key={video.id} className="video-player-container">
              <VideoPlayer
                key={'player' + video.id}
                ref={video.player}
                video={video.id}
                paused={video.paused}
                autoplay={false}
                onReady={d => this.playerReady(video.id, d)}
                onError={e => this.playerError(video.id, e)}
                onPlayRequest={() => this.play(video.id)}
                onTogglePlayRequest={() => this.togglePlay(video.id)}
                onPauseRequest={() => this.pause(video.id)}
                onPlay={this.handlePlay}
                onPause={this.handlePause}
                onEnd={() => this.handleEnd(video.id)}
                moveDisabled={video.type !== 'film'}
                hideControls={!video.started}
                node={this.salleRef.current}
                onShowControls={this.handleShowControls}
                onHideControls={this.handleHideControls}
                isFilm={video.type === 'film'}
                startTime={this.state.filmStartAt}
                onTick={this.timeCounter.tick}
                {...this.props}
              />
            </div>
          ))}
          {introReady &&
            intro.map(item => (
              <div key={item.fileName} className="video-player-container">
                <video className="video-player-intro" ref={item.ref} playsInline src={item.blobUrl} />
              </div>
            ))}
          {seanceFull.event_id > 0 && liveStarted && !filmEnded && (
            <div className="seance-osd">
              <Button color="primary" size="small" variant="outlined" onClick={this.next}>
                {t('quitter-le-film-pour-rejoindre-la-rencontre')}
              </Button>
            </div>
          )}
          {filmEnded && position > 0 && position < filmDuration - 30 && (
            <div className="seance-osd">
              <Button color="primary" size="small" variant="outlined" onClick={() => window.location.reload()}>
                {t('reprendre-le-film')}
              </Button>
            </div>
          )}
        </div>
        {this.renderTeaser()}
      </div>
    );
  }
  handleChangeNewslettersSeance(event) {
    let {value} = event.target;
    value = event.target.checked ? 1 : 0;
    let cinema = _.find(this.props.modele.cinemas, {cinema_id: parseInt(this.state.seanceIndex?.cinema_id)});

    let user = this.props.appState.user;
    let newsletter = this.state.newsletter[0];

    if (!newsletter) {
      //NEWSLETTER FIRST SUB
      //UPDATE DB
      var m = new Date();
      var dateString =
        m.getUTCFullYear() +
        '-' +
        (m.getUTCMonth() + 1) +
        '-' +
        m.getUTCDate() +
        ' ' +
        m.getUTCHours() +
        ':' +
        m.getUTCMinutes() +
        ':' +
        m.getUTCSeconds();

      let formData = new FormData();
      formData.append('cinema_id', this.state.seanceIndex?.cinema_id);
      formData.append('optin', 1);
      formData.append('optin_date', dateString);
      user._method = 'PUT';
      axios
        .post(Conf.apiBaseUriLegacy + `/newsletter`, formData, {
          withCredentials: true,
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        })
        .then(res => {
          //   console.log(`create newsletter cinema_id=${this.state.seanceIndex?.cinema_id} optin=1`, res);
          //UPDATE STATE
          axios.get(Conf.apiBaseUriLegacy + '/newsletters', {withCredentials: true}).then(res => {
            this.setState({
              news: res.data,
              newsletter: res.data
                ? res.data.filter(n => n.cinema_id === parseInt(this.state.seanceIndex?.cinema_id))
                : [],
            });
          });
        });
    } else if (newsletter) {
      //NEWSLETTER UPDATE
      //UPDATE DB
      let formData = new FormData();
      formData.append('optin', newsletter.optin ? 0 : 1);
      user._method = 'PUT';
      axios
        .post(Conf.apiBaseUriLegacy + `/newsletter/${newsletter.id}`, formData, {
          withCredentials: true,
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        })
        .then(res => {
          console.log(`update newsletter id=${newsletter.id} optin=${newsletter.optin ? 0 : 1}`, res);

          //UPDATE STATE
          let newsletters = JSON.parse(JSON.stringify(this.state.news));
          let indexCurrentNews = newsletters.findIndex(e => e.cinema_name === cinema.cinema_name);
          newsletters[indexCurrentNews]['optin'] = value;
          this.setState({
            news: newsletters,
            newsletter: newsletters
              ? newsletters.filter(n => n.cinema_id === parseInt(this.state.seanceIndex?.cinema_id))
              : [],
          });
        });
    }
  }
  render() {
    if (!this.state.seanceIndex) {
      return '';
    }
    const {
      seanceIndex,
      ready,
      seance,
      seanceStarted,
      showControls,
      top,
      left,
      ratio,
      seanceStartSoon,
      filmEnded,
      playing,
      full,
      intro,
      chat,
      showChat,
      preloadProgress,
      accessGranted,
      checkOpen,
      seanceLoginOpen,
      videoNeedInteraction,
      accessDeniedMsg,
      bookOpen,
    } = this.state;
    const {t} = this.props;
    const {appState, modele} = this.context;
    const {mes_seances} = appState.user;
    const seanceIsInMesSeances = mes_seances && _.findIndex(mes_seances, {seance_id: seanceIndex.seance_id}) !== -1;
    const shouldShowNewsletterCheckbox = appState.conf.NEWSLETTER_ENABLED;

    const viewportStyle = {
      transform: 'scale(' + ratio + ')',
      top,
      left,
    };
    let backgroundStyle = {
      backgroundImage: `url('${defaultCinemaBackground}')`,
    };
    if (seanceIndex.background) {
      // let basename = seanceIndex.background.split(/[\\/]/).pop();
      // let background = seanceIndex.background.replace(basename, 'min/' + basename);
      backgroundStyle.backgroundImage = `url("${Conf.assetsRoot + seanceIndex.background}")`;
      viewportStyle.backgroundImage =
        seanceStartSoon && !filmEnded ? '' : `url("${Conf.assetsRoot + seanceIndex.background}")`;
    }
    let langselectorClasses = 'screen-lang-selector';
    if (
      !seanceStarted ||
      (!filmEnded && (showControls || !playing)) ||
      (filmEnded && !full) ||
      (filmEnded && full && showControls)
    )
      langselectorClasses += ' show';

    const chatVisible = !seanceStarted || showControls || (filmEnded && !full);

    return (
      <div className="seance-wrapper">
        <div
          className={this.getSeanceClasses()}
          ref={this.salleRef}
          onDoubleClick={seanceStarted ? this.toggleFullScreen : undefined}
        >
          {intro.length > 0 && <video ref={this.videoRef} playsInline src={intro[0].blobUrl} />}
          <div className={`seance-container-inner${ready ? ' show' : ''}`} style={viewportStyle}>
            {!!seanceIndex.event_id && showChat && (
              <div className={'chat-container'}>
                <Chat
                  pseudo={appState.user.pseudo}
                  onSend={this.handleChatSend}
                  messages={chat}
                  notFull={seanceStarted && (!filmEnded || full)}
                  visible={chatVisible}
                />
              </div>
            )}
            {this.renderEcran(backgroundStyle)}
            {accessGranted && (
              <div className={langselectorClasses}>
                <LanguageSelector appState={appState} container={this.salleRef.current} />
              </div>
            )}
          </div>
          {preloadProgress < 100 && (
            <div className="seance-loader">
              <LinearProgress variant="determinate" value={preloadProgress} />
            </div>
          )}
          {!seanceIndex.local && !seance && <PaiementHorsZone />}
          {seanceIndex.local && !seance && (
            <>
              <Paiement
                {...this.props}
                open={checkOpen}
                onClose={this.handleCheckClose}
                seance={seanceIndex}
                checkOnly={true}
                onSuccess={this.handleSuccess}
                container={this.salleRef.current}
                keepOpen
              />
              <Dialog open={bookOpen} scroll="body" className="my-dialog" container={this.salleRef.current}>
                <DialogContent>
                  <CartoucheSeance hideBtns seance={seanceIndex} appState={appState} modele={modele} />
                  <Typography variant="h6" component="h2" noWrap>
                    {t('gratuit')}
                  </Typography>
                </DialogContent>
                <DialogActions style={{display: 'flex', justifyContent: 'space-between'}}>
                  {!!shouldShowNewsletterCheckbox && (
                    <div>
                      <Checkbox
                        color="default"
                        checked={
                          this.state.newsletter && this.state.newsletter.length > 0
                            ? this.state.newsletter[0].optin === 1
                              ? true
                              : false
                            : false
                        }
                        onChange={this.handleChangeNewslettersSeance}
                        name={this.state.newsletter ? this.state.newsletter.cinema_name : seanceIndex.cinema_name}
                        inputProps={{'aria-label': 'primary Checkbox'}}
                      />
                      {t(`newsletter-du-cinéma`) + ` «${seanceIndex.cinema_name}»`}
                    </div>
                  )}
                  {seanceIsInMesSeances && (
                    <Button
                      disabled={seanceIndex.ended}
                      className="seance-btn"
                      color="primary"
                      size="small"
                      variant="contained"
                      onClick={this.handleSuccess}
                    >
                      {t('acceder-a-la-seance')}
                    </Button>
                  )}
                  {!seanceIsInMesSeances && <BookButton {...this.props} seance={seanceIndex} />}
                </DialogActions>
              </Dialog>
            </>
          )}
          <SeanceLogin
            seance={seanceIndex}
            {...this.props}
            open={seanceLoginOpen}
            onLogin={this.handleLoggedIn}
            onClose={this.handleSeanceLoginClose}
          />
          <Dialog open={videoNeedInteraction} onClose={this.autoPlayCheck} className="my-dialog">
            <DialogContent>
              <DialogContentText>{t('bienvenue-dans-votre-salle-de-cinema-virtuelle')}</DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button color="primary" onClick={this.autoPlayCheck}>
                {t('entrer')}
              </Button>
            </DialogActions>
          </Dialog>
          <Dialog open={Boolean(accessDeniedMsg)} className="my-dialog" container={this.salleRef.current}>
            <DialogContent>
              <DialogContentText>{accessDeniedMsg}</DialogContentText>
            </DialogContent>
          </Dialog>
        </div>
        {!accessGranted && (
          <div className="seance-lang-selector" style={{right: left + 15}}>
            <LanguageSelector appState={appState} />
          </div>
        )}
      </div>
    );
  }
}

Seance.contextType = Context;

export default withTranslation()(Seance);
